import client from "../api/client";


export const getLayer = async (layerId) => {
  let path = `/api/private/v3/layer/get/${layerId}`;
  try {
    const response = await client.get(path);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const createLayer = async (data) => {
  try {
    const response = await client.post(`/api/private/v3/layer/save`, data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const updateLayer = async (data) => {
  try {
    const response = await client.put(`/api/private/v3/layer/update`, data);
    return response?.data;
  } catch (err) {
    throw err;
  }
};

export const deleteLayer = async (id) => {
  try {
    const response = await client.delete(`/api/private/v3/layer/delete/${id}`);
    return response?.data;
  } catch (err) {
    throw err;
  }
};
